import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './checkin-passenger-addition-result.actions';
import { CheckinPassengerAdditionResultState } from './checkin-passenger-addition-result.state';

/**
 * checkinPassengerAdditionResult initial state
 */
export const checkinPassengerAdditionResultInitialState: CheckinPassengerAdditionResultState = {
  requestIds: [],
};

/**
 * List of basic actions for CheckinPassengerAdditionResult Store
 */
export const checkinPassengerAdditionResultReducerFeatures: ReducerTypes<
  CheckinPassengerAdditionResultState,
  ActionCreator[]
>[] = [
  on(actions.setCheckinPassengerAdditionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCheckinPassengerAdditionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCheckinPassengerAdditionResult, () => checkinPassengerAdditionResultInitialState),

  on(actions.cancelCheckinPassengerAdditionResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCheckinPassengerAdditionResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setCheckinPassengerAdditionResultFromApi,
    actions.updateCheckinPassengerAdditionResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CheckinPassengerAdditionResult Store reducer
 */
export const checkinPassengerAdditionResultReducer = createReducer(
  checkinPassengerAdditionResultInitialState,
  ...checkinPassengerAdditionResultReducerFeatures
);
